/* eslint-disable no-mixed-operators */
import { FormProvider } from 'contexts/formContext';
import { BankAccountApprovalsFilters } from './BankAccountApprovalsFilters';
import { bankAccountApprovalsFiltersSchema, defaultValuesBankAccountApprovalsFilters } from './BankAccountApprovalsFiltersSchema';
import { useFilters } from 'contexts/filterContext';
import { BankAccountApprovalType } from 'services/approvals/approvals';

type BankAccountApprovalsFiltersContainerProps = {
    approvalType: BankAccountApprovalType
}

export const BankAccountApprovalsFiltersContainer = ({ approvalType }: BankAccountApprovalsFiltersContainerProps) => {
    const { filters, addFilter, removeFilterByIndex } = useFilters();

    const onSubmitSearch = (values: any) => {
        addFilter(values.optionFilter, values[values.optionFilter]);
    };

    return (
        <>
            <FormProvider
                defaultValues={defaultValuesBankAccountApprovalsFilters()}
                validationSchema={bankAccountApprovalsFiltersSchema()}
                onSubmit={onSubmitSearch}
            >
                <BankAccountApprovalsFilters
                    currentValues={filters}
                    removeFilterSelected={removeFilterByIndex}
                    approvalType={approvalType}
                />
            </FormProvider>
        </>
    )
}
